export default __webpack_public_path__ + "static/Trustender_logo-e4418824776c53dbc072cf712307e2f6.png";